// What kind of deployment the app is running on, as the pages need it
// (#11422 round 19, R8).
//
// A PHI document-review deployment (the isolated tenant that reviews PHI
// documents) shows the intake queue at /documents; every other deployment
// shows the documents product there. The boot fetch decides it before sign-in
// (`stytchPublicTokens.ts`), and `main.jsx` provides the answer once at the
// app's root, so the routes and the loading placeholder read the same value.
// Never an organization or a client: the deployment's posture alone.
import { createContext, useContext } from "react";

/** False outside a provider: what every shared deployment is. */
export const PhiDocumentReviewContext = createContext<boolean>(false);

/** Whether this deployment reviews PHI documents (/documents is the intake
 *  queue). */
export const usePhiDocumentReview = (): boolean =>
  useContext(PhiDocumentReviewContext);
